import { Input } from "components/common/Input/Input";
import { Translate } from "components/common/Translate/Translate";
import { ChangeEvent } from "react";
import { useTop } from "./useTop";

export interface TopProps {
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Top = ({ handleChange }: TopProps) => {
    const { top } = useTop();

    return (
        <div className="my-4">
            <div className="capitalize mb-4" data-testid="top-input-label">
                <Translate keyName="position" /> (Y)
            </div>
            <Input
                className="w-full"
                type="number"
                min={0}
                value={Math.round(top)}
                onChange={handleChange}
                data-testid="top-input"
            />
        </div>
    );
};
